import { createCanBoundTo } from "@casl/react";
import ability_ from "../casl/ability";

export const ability = ability_;
export default createCanBoundTo(ability_);
